export default "__VITE_ASSET__DyV3SwQX__"